import { render, staticRenderFns } from "./ysgk.vue?vue&type=template&id=f4c8e0a2&scoped=true"
import script from "./ysgk.vue?vue&type=script&lang=js"
export * from "./ysgk.vue?vue&type=script&lang=js"
import style0 from "./ysgk.vue?vue&type=style&index=0&id=f4c8e0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c8e0a2",
  null
  
)

export default component.exports